import { render, staticRenderFns } from "./PostPage.vue?vue&type=template&id=c7adaa72&"
import script from "./PostPage.vue?vue&type=script&lang=js&"
export * from "./PostPage.vue?vue&type=script&lang=js&"
import style0 from "./PostPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports